module.exports = __webpack_public_path__ + "img/icon_card7.b886c7aa.png";